import axios from "@util/axios";

class HelpService {
	async send(data) {
		const response = await axios({
			url: `/auth/email/help/`,
			method: "POST",
			data: data,
		});

		return response;
	}
}

export default new HelpService();
